module.exports = __webpack_public_path__ + "img/NorwayAccent.fedeb10f.svg";